import React, { useState } from "react";
import { toast } from "react-toastify";
import { privateAPI } from "../../../../utils/api";
import { getCookie } from "../../../../utils/cookie";
import { HeaderTextButton } from '../../../../common/Header/styles';
import {
  ProductWrapper,
  ProductData,
  ProductImage,
  ProductDataInfo,
  ButtonsWrapper,
  InputQuantity
} from '../styles';

const CartProduct = ({...props}) => {
  const [userID] = useState(getCookie('userId'));
  let [productQuantity, setProductQuantity] = useState(props.item.cartQuantity);

  const setProductInCart = async () => {
    try{
        const productDTO = {
            productId: props.item.id,
            quantity: productQuantity,
            userId: userID
        }
        await privateAPI.post(`/auth/bacchus/client/cart`, productDTO);
        toast.success('Updated!');
        props.getUserCart();
    } catch (error){
        if(error.request && error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const removeProductFromCart = async () => {
    try{
        await privateAPI.delete(`/auth/bacchus/client/cart/${props.productID}`);
        toast.success('Product is removed!');
        props.getUserCart();
    } catch (error){
        if(error.request && error.request.status === 500) return toast.error('Internal server error')
    }
  }

  return (
    <ProductWrapper key={props.item.id}>
      <ProductData>
        <ProductImage src={props.item.image}/>
        <ProductDataInfo>
          <h4>{props.item.name}</h4>
          <p>quantity: {props.item.cartQuantity}</p>
        </ProductDataInfo>
      </ProductData>
      <ProductDataInfo center>
        <ButtonsWrapper>
          <button
            style={{ border: "none", background: "none", width: "15px" }}
            onClick={() => productQuantity && setProductQuantity(--productQuantity)}
            disabled={productQuantity === 0}
            >
            -
          </button>
          <InputQuantity
            type="number"
            min={0}
            max={props.item.stock}
            value={productQuantity}
            onChange={(e) => setProductQuantity(e.target.value)}
            />
          <button
            style={{ border: "none", background: "none", width: "15px" }}
            onClick={() => setProductQuantity(++productQuantity)}
            disabled={productQuantity >= props.item.stock}
            >
            +
          </button>
        </ButtonsWrapper>
        <HeaderTextButton cream right onClick={productQuantity <= props.item.stock ? () => setProductInCart() : () => toast.info('Over stock')}>Update</HeaderTextButton>
        <HeaderTextButton red onClick={removeProductFromCart}>Remove</HeaderTextButton>
      </ProductDataInfo>
    </ProductWrapper>
  );
};

export default CartProduct;
